import { inject, Injectable } from "@angular/core";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { SourceCategory } from "@bitwarden/web-vault/app/models/data/blobby/source-category";
import { SplitCategoryTypeOld } from "@bitwarden/web-vault/app/models/types/split-category-type";

import { Category, getDefaultCategory } from "../../../models/data/blobby/category.data";
import { DataRepositoryService } from "../../DataRepository/data-repository.service";
import { DataServiceAbstraction } from "../data.service.abstraction";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";
import { CategoryStoreModel } from "@bitwarden/web-vault/app/models/store/category.store.model";
import { SourceCategoryView } from "@bitwarden/web-vault/app/models/view/source-category/source-category.view";
import { ImportStoreService } from "@bitwarden/web-vault/app/services/store/import/import.store.service";

@Injectable({
  providedIn: "root",
})
//TODO: @mmeshel want to deprecate this service after we rebuild the category UI
export class CategoryService implements DataServiceAbstraction {
  constructor(
    private logService: LogService,
    private dataRepositoryService: DataRepositoryService,
    private i18n: I18nService,
  ) {}

  /**
   * @deprecated
   */
  async create(newCat: Category): Promise<Category> {
    try {
      return await this.dataRepositoryService.createCategory(newCat);
    } catch (e) {
      this.logService.error(e);
      throw e;
    }
  }

  /**
   * @deprecated
   */
  async createSourceCategory(sourceCategory: SourceCategory): Promise<SourceCategory> {
    try {
      return await this.dataRepositoryService.createSourceCategory(sourceCategory);
    } catch (e) {
      this.logService.error(e);
      throw e;
    }
  }

  /**
   * @deprecated
   */
  async update(catToBeUpdated: Category, triggerObservable: boolean): Promise<Category> {
    try {
      const updatedCategory = await this.dataRepositoryService.updateCategory(catToBeUpdated);
      if (triggerObservable) {
        // todo refactor updateObservables await this.updateObservables();
      }
      return updatedCategory;
    } catch (e) {
      this.logService.error(e);
      throw e;
    }
  }

  /**
   * @deprecated
   */
  async delete(category: Category, triggerObservable: boolean): Promise<boolean> {
    try {
      const success = await this.dataRepositoryService.deleteCategory(category);

      if (triggerObservable) {
        // todo refactor updateObservables await this.updateObservables();
      }
      return success;
    } catch (e) {
      this.logService.error(e.message);
      throw e;
    }
  }

  /**
   * @deprecated
   */
  async getAll(): Promise<Category[]> {
    return await this.dataRepositoryService.getAllCategories();
  }

  /**
   * @deprecated
   */
  async get(categoryId: string): Promise<Category> {
    // TODO handle edge cases
    const allCats = await this.dataRepositoryService.getAllCategories();
    try {
      return allCats.filter((cat) => cat.id === categoryId)[0];
    } catch (e) {
      throw new Error("Method not implemented.");
    }
  }

  /**
   * @deprecated
   */
  async getByName(catName: string) {
    try {
      const categories = await this.getAll();
      return categories.find((cat) => cat.name === catName);
    } catch (e) {
      this.logService.error(e);
    }
  }
}
